document.addEventListener("DOMContentLoaded", () => {
  // Ensure GSAP and ScrollTrigger are loaded
  if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;

  gsap.registerPlugin(ScrollTrigger);

  // Check for mobile or reduced motion preference
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const disableHeavyAnimations = isMobile || prefersReducedMotion;

  // Hero Text Preparation (Split words for elegant animation)
  const heroTitles = document.querySelectorAll('.mockup-hero__title');
  heroTitles.forEach(heroTitle => {
    const lines = heroTitle.innerHTML.split(/<br\s*\/?>/i);
    const wrappedLines = lines.map(line => {
      return line.split(' ').map(word => {
        if (!word.trim()) return word;
        return `<span style="display:inline-block; overflow:hidden; vertical-align:top; padding-right:0.2em;"><span class="gs-hero-word-inner" style="display:inline-block; transform-origin: left bottom;">${word}</span></span>`;
      }).join('');
    });
    heroTitle.innerHTML = wrappedLines.join('<br>');
  });

  function playHeroAnimation() {
    const heroTl = gsap.timeline();
    // Only animate the first slide initially
    const firstSlide = document.querySelector('.hero-slide');
    if (!firstSlide) return;

    const words = firstSlide.querySelectorAll('.gs-hero-word-inner');
    if (words.length > 0) {
      if (disableHeavyAnimations) {
        gsap.to(words, { y: '0%', opacity: 1, duration: 0.5 });
      } else {
        heroTl.fromTo(words, 
          { y: '120%', rotateZ: 5, opacity: 0 },
          { y: '0%', rotateZ: 0, opacity: 1, duration: 1.2, stagger: 0.05, ease: "power4.out" }
        );
      }
    }
    const sub = firstSlide.querySelector('.gs-hero-subtitle');
    if (sub) {
      if (disableHeavyAnimations) {
         gsap.to(sub, { y: 0, opacity: 1, filter: 'blur(0px)', duration: 0.5 });
      } else {
        heroTl.fromTo(sub, 
          { y: 30, opacity: 0, filter: 'blur(8px)' },
          { y: 0, opacity: 1, filter: 'blur(0px)', duration: 1.2, ease: "power3.out" },
          "-=0.9"
        );
      }
    }
    const pop = firstSlide.querySelector('.gs-hero-pop');
    if (pop) {
      if (disableHeavyAnimations) {
         gsap.to(pop, { scale: 1, opacity: 1, duration: 0.5 });
      } else {
        heroTl.fromTo(pop, 
          { scale: 0.85, opacity: 0 },
          { scale: 1, opacity: 1, duration: 1.5, ease: "elastic.out(1, 0.6)" },
          "-=1.0"
        );
      }
    }
  }

  // 0. Preloader Logic
  const preloader = document.getElementById('preloader');
  if (preloader) {
    const tl = gsap.timeline({
      onComplete: () => {
        preloader.style.display = 'none';
        playHeroAnimation();
      }
    });

    tl.to('.preloader-logo', { opacity: 1, y: 0, duration: 0.8, ease: "power2.out" })
      .to('.preloader-progress', { width: "100%", duration: 1.2, ease: "power1.inOut" }, "-=0.2")
      .to(preloader, { opacity: 0, duration: 0.6, ease: "power2.inOut" }, "+=0.2");
  } else {
    // Play immediately if no preloader
    playHeroAnimation();
  }

  // Initialize Lenis Smooth Scroll (Disable on mobile to prevent jank)
  if (typeof Lenis !== 'undefined' && !disableHeavyAnimations) {
    const lenis = new Lenis({
      duration: 1.2,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)), 
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    });

    lenis.on('scroll', ScrollTrigger.update);
    gsap.ticker.add((time) => {
      lenis.raf(time * 1000);
    });
    gsap.ticker.lagSmoothing(0);
  }

  // 1. Hero Fullscreen Carousel & Parallax
  const heroSection = document.querySelector('.mockup-hero');
  if (heroSection) {
    const slides = gsap.utils.toArray('.hero-slide');
    if (slides.length > 1) {
      // Setup initial state
      slides.forEach((slide, i) => {
        if (i === 0) {
          gsap.set(slide, { opacity: 1, zIndex: slides.length });
        } else {
          gsap.set(slide, { opacity: 0, zIndex: slides.length - i });
        }
      });

      // Auto-Rotate Timeline (Crossfade)
      let currentSlideIndex = 0;
      setInterval(() => {
        const nextSlideIndex = (currentSlideIndex + 1) % slides.length;
        
        const currentSlide = slides[currentSlideIndex];
        const nextSlide = slides[nextSlideIndex];
        
        const currentWords = currentSlide.querySelectorAll('.gs-hero-word-inner');
        const currentSub = currentSlide.querySelector('.gs-hero-subtitle');
        const currentPop = currentSlide.querySelector('.gs-hero-pop');
        
        const nextWords = nextSlide.querySelectorAll('.gs-hero-word-inner');
        const nextSub = nextSlide.querySelector('.gs-hero-subtitle');
        const nextPop = nextSlide.querySelector('.gs-hero-pop');

        if (disableHeavyAnimations) {
           gsap.to(currentSlide, { opacity: 0, zIndex: 0, duration: 1 });
           gsap.to(nextSlide, { opacity: 1, zIndex: slides.length, duration: 1 });
           gsap.set(nextWords, { y: '0%', opacity: 1 });
           if(nextSub) gsap.set(nextSub, { y: 0, opacity: 1, filter: 'blur(0px)' });
           if(nextPop) gsap.set(nextPop, { scale: 1, opacity: 1 });
        } else {
          // Transition out current slide elements
          if (currentWords.length > 0) gsap.to(currentWords, { y: '-120%', opacity: 0, duration: 0.8, ease: "power2.in" });
          if (currentSub) gsap.to(currentSub, { y: -30, opacity: 0, filter: 'blur(8px)', duration: 0.8, ease: "power2.in" });
          if (currentPop) gsap.to(currentPop, { scale: 0.85, opacity: 0, duration: 0.8, ease: "power2.in" });

          // Transition in next slide elements
          if (nextWords.length > 0) gsap.fromTo(nextWords, { y: '120%', rotateZ: 5, opacity: 0 }, { y: '0%', rotateZ: 0, opacity: 1, duration: 1.2, stagger: 0.05, ease: "power4.out", delay: 0.5 });
          if (nextSub) gsap.fromTo(nextSub, { y: 30, opacity: 0, filter: 'blur(8px)' }, { y: 0, opacity: 1, filter: 'blur(0px)', duration: 1.2, ease: "power3.out", delay: 0.7 });
          if (nextPop) gsap.fromTo(nextPop, { scale: 0.85, opacity: 0 }, { scale: 1, opacity: 1, duration: 1.5, ease: "elastic.out(1, 0.6)", delay: 0.8 });

          gsap.to(currentSlide, { opacity: 0, zIndex: 0, duration: 1.5, ease: "power2.inOut" });
          gsap.to(nextSlide, { opacity: 1, zIndex: slides.length, duration: 1.5, ease: "power2.inOut" });
        }
        
        currentSlideIndex = nextSlideIndex;
      }, 5000); // 5 seconds interval
      
      // Parallax Scroll Animation for all slide images
      if (!disableHeavyAnimations) {
        slides.forEach((slide) => {
          const img = slide.querySelector('img, svg');
          if (img) {
            gsap.fromTo(img, { scale: 1 }, {
                scale: 1.15,
                ease: "none",
                scrollTrigger: {
                    trigger: heroSection,
                    start: "top top",
                    end: "bottom top",
                    scrub: true
                }
            });
          }
        });
      }
    }
  }

  // 2. Global Scroll Reveals for Sections
  const sections = document.querySelectorAll('.gs-section');
  sections.forEach((section) => {
    const reveals = section.querySelectorAll('.gs-reveal');
    if (reveals.length > 0) {
      gsap.fromTo(reveals, 
        { y: 40, opacity: 0 },
        {
          y: 0, opacity: 1, duration: 1, stagger: 0.15, ease: "power3.out",
          scrollTrigger: {
            trigger: section,
            start: "top 80%",
            toggleActions: "play none none reverse"
          }
        }
      );
    }
    const imageReveals = section.querySelectorAll('.gs-reveal-img img');
    if (imageReveals.length > 0) {
      gsap.fromTo(imageReveals,
        { scale: 1.15, filter: 'brightness(0.8)' },
        {
          scale: 1, filter: 'brightness(1)', duration: 1.5, ease: "power3.out",
          scrollTrigger: { trigger: section, start: "top 80%" }
        }
      );
    }
  });

  // 3. Infinite Interactive Marquee (Trust Banner)
  const marqueeTrack = document.querySelector('.mockup-marquee__track');
  if (marqueeTrack) {
    marqueeTrack.style.animation = 'none';
    const content = document.querySelector('.mockup-marquee__content');
    marqueeTrack.appendChild(content.cloneNode(true));
    const marqueeWidth = content.offsetWidth;
    let tl = gsap.to('.mockup-marquee__track', {
      x: () => `-=${marqueeWidth}`,
      ease: "none",
      duration: 30,
      repeat: -1,
      modifiers: { x: gsap.utils.unitize(x => parseFloat(x) % marqueeWidth) }
    });
    ScrollTrigger.create({
      onUpdate: (self) => {
        let velocity = Math.abs(self.getVelocity());
        if(velocity > 0) gsap.to(tl, {timeScale: 1 + (velocity / 500), duration: 0.5, overwrite: true});
        else gsap.to(tl, {timeScale: 1, duration: 1, overwrite: true});
      }
    });
  }

  // 4. Collection Masonry Grid Enhancements
  const maskWrappers = document.querySelectorAll('.gs-reveal-mask');
  maskWrappers.forEach((mask) => {
    gsap.to(mask, {
      clipPath: "inset(0% 0% 0% 0%)",
      duration: 1.5,
      ease: "power4.inOut",
      scrollTrigger: { trigger: mask, start: "top 90%" }
    });
  });

  gsap.to(".gs-parallax-slow .m-card__image img", {
    yPercent: -10, ease: "none",
    scrollTrigger: { trigger: ".mockup-collection", start: "top bottom", end: "bottom top", scrub: true }
  });

  gsap.to(".gs-parallax-fast .m-card__image img", {
    yPercent: 10, ease: "none",
    scrollTrigger: { trigger: ".mockup-collection", start: "top bottom", end: "bottom top", scrub: true }
  });

  const cards = document.querySelectorAll('.m-card');
  cards.forEach(card => {
    card.addEventListener('mousemove', e => {
      const rect = card.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;
      const centerX = rect.width / 2;
      const centerY = rect.height / 2;
      const rotateX = (y - centerY) / 20;
      const rotateY = (centerX - x) / 20;
      gsap.to(card, { rotateX: rotateX, rotateY: rotateY, scale: 1.02, duration: 0.5, ease: "power2.out" });
    });
    card.addEventListener('mouseleave', () => {
      gsap.to(card, { rotateX: 0, rotateY: 0, scale: 1, duration: 0.5, ease: "power2.out" });
    });
  });

  // 5. Sophisticated Split-Text Animation
  const splitTitles = document.querySelectorAll('.gs-split-text');
  splitTitles.forEach(title => {
    const words = title.innerText.split(' ');
    title.innerHTML = words.map(word => `<span class="gs-word" style="display:inline-block;">${word}</span>`).join(' ');
    gsap.from(title.querySelectorAll('.gs-word'), {
      yPercent: 100, opacity: 0, rotateX: -45, duration: 1.2, stagger: 0.1, ease: "power4.out",
      scrollTrigger: { trigger: title, start: "top 85%" }
    });
  });

  // 6. Section Change "Peel" Effect
  gsap.from(".mockup-benefits", {
    yPercent: 30, ease: "none",
    scrollTrigger: { trigger: ".mockup-benefits", start: "top bottom", end: "top top", scrub: true }
  });

  // 7. Benefit Icons SVG Drawing Animation
  const benefitIcons = document.querySelectorAll('.benefit-icon svg');
  benefitIcons.forEach((svg) => {
    const paths = svg.querySelectorAll('path, rect');
    paths.forEach(path => {
      const length = path.getTotalLength();
      gsap.set(path, { strokeDasharray: length, strokeDashoffset: length });
      gsap.to(path, { strokeDashoffset: 0, duration: 2.5, ease: "power2.out", scrollTrigger: { trigger: svg, start: "top 90%" } });
    });
  });

  // 8. Spotlight Dashboard Interaction
  const spotlightTabs = document.querySelectorAll('.spotlight-tab');
  const spotlightData = {
    protein: {
      standard: { val: '10g', scale: 0.8, desc: 'Mass-produced grains, stripped of natural bran.' },
      grainary: { val: '15g', scale: 1.3, desc: 'Heritage seeds, stone-ground to preserve every nutrient.' }
    },
    fiber: {
      standard: { val: '2g', scale: 0.4, desc: 'Refined processing removes nearly all essential fiber.' },
      grainary: { val: '10g', scale: 1.5, desc: 'High-retention milling keeps 100% of the natural fiber.' }
    },
    traceability: {
      standard: { val: 'None', scale: 0.5, desc: 'Unknown origin, mixed from global industrial silos.' },
      grainary: { val: '100%', scale: 1.4, desc: 'Every batch is traceable back to the specific farm and soil.' }
    },
    purity: {
      standard: { val: 'Additives', scale: 0.6, desc: 'Often contains bleaching agents and preservatives.' },
      grainary: { val: 'Pure', scale: 1.4, desc: 'Zero chemicals. Zero additives. Just the grain.' }
    }
  };

  spotlightTabs.forEach(tab => {
    tab.addEventListener('click', () => {
      spotlightTabs.forEach(t => t.classList.remove('active'));
      tab.classList.add('active');
      const target = tab.getAttribute('data-target');
      const selected = spotlightData[target];
      const tl = gsap.timeline();
      tl.to(['#value-standard', '#value-grainary', '#desc-standard', '#desc-grainary'], { opacity: 0, y: 10, duration: 0.2 });
      tl.add(() => {
        document.getElementById('value-standard').innerText = selected.standard.val;
        document.getElementById('value-grainary').innerText = selected.grainary.val;
        document.getElementById('desc-standard').innerText = selected.standard.desc;
        document.getElementById('desc-grainary').innerText = selected.grainary.desc;
      });
      tl.to('#visual-standard', { scale: selected.standard.scale, duration: 0.6, ease: "back.out(1.7)" }, "visual");
      tl.to('#visual-grainary', { scale: selected.grainary.scale, duration: 0.6, ease: "back.out(1.7)" }, "visual");
      tl.to(['#value-standard', '#value-grainary', '#desc-standard', '#desc-grainary'], { opacity: 1, y: 0, duration: 0.4, stagger: 0.05 });
    });
  });

  // 9. Community Reviews Auto-Scroll (Disabled in favor of native scroll)
  /*
  const reviewTrack = document.querySelector('.mockup-reviews__slider');
  if (reviewTrack) {
    const reviews = gsap.utils.toArray('.review-card');
    const totalWidth = reviewTrack.scrollWidth;
    
    // Auto-scroll loop
    gsap.to(reviewTrack, {
      x: () => `-=${totalWidth / 2}`, 
      ease: "none",
      duration: 40,
      repeat: -1
    });
  }
  */

});